import React, { Component } from 'react';
import styles from './styles/direct-link.module.css';
import { connect } from 'react-redux';
import { Row, Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import Chatbot from '@/components/chatbot/Chatbot';

class DirectLink extends Component {

  render() {
    return (
      <div style={this.props.loading ? { justifyContent: 'center', alignContent: 'center' } : null}
           className={styles.wrapper}>
        {this.props.loading ? <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
          : <Row className={styles.chatbot_wrapper}>
            <Chatbot hideCloseBtn />
          </Row>
        }
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.chatbotDetails.loading,
  settings: state.chatbotDetails.settings,
  company: state.chatbotDetails.company,
});

export default connect(mapStateToProps)(DirectLink);